import type { CustomHeaderProps } from 'ag-grid-react'
import { Pencil } from 'lucide-react'
import { DagColumnHeaderLabel } from './DagColumnHeaderLabel'

interface DagBulkEditColumnHeaderProps extends CustomHeaderProps {
  onOpenBulkEditColumn: () => void
  isRequiredInput?: boolean
  isReorderable?: boolean
}

export function DagBulkEditColumnHeader(props: DagBulkEditColumnHeaderProps) {
  const { displayName, onOpenBulkEditColumn, isRequiredInput, isReorderable } =
    props

  return (
    <div className="flex items-center gap-1 min-w-0">
      <DagColumnHeaderLabel
        displayName={displayName}
        isRequiredInput={isRequiredInput}
        isReorderable={isReorderable}
      />
      <Pencil
        className="h-3 w-3 shrink-0 cursor-pointer text-muted-foreground hover:text-foreground"
        onClick={e => {
          e.stopPropagation()
          onOpenBulkEditColumn()
        }}
      />
    </div>
  )
}
